const RETURN_PATH_KEY = 'ecartpay_admin_return_path';
const KEEP_QUERY_ACCOUNT_KEY = 'ecartpay_admin_keep_query_account';
const HOME_PATH = '/home';

const BLOCKED_PATHS = new Set([
    '/login',
    '/two-step-auth',
    '/two-step-auth/register',
    '/expired-password',
    '/update-password',
    '/recovery-password',
    '/invitation/sign-up',
]);

function pathnameOf(full_path) {
    const without_hash = full_path.split('#')[0];
    const pathname = without_hash.split('?')[0];
    try {
        return decodeURIComponent(pathname);
    } catch {
        return '';
    }
}

export function isReturnablePath(full_path) {
    if (typeof full_path !== 'string' || full_path.length === 0) {
        return false;
    }
    if (!full_path.startsWith('/') || full_path.startsWith('//')) {
        return false;
    }
    const pathname = pathnameOf(full_path);
    if (!pathname.startsWith('/') || pathname.startsWith('//')) {
        return false;
    }
    if (pathname.includes('\\') || pathname.includes('://')) {
        return false;
    }
    if (BLOCKED_PATHS.has(pathname)) {
        return false;
    }
    return true;
}

function pinsAccount(full_path) {
    const pathname = pathnameOf(full_path);
    const is_account_page = pathname.startsWith('/accounts/info') || pathname.startsWith('/accounts/v2');
    if (!is_account_page) {
        return false;
    }
    const query_string = full_path.split('#')[0].split('?')[1] || '';
    const account_id = new URLSearchParams(query_string).get('id');
    return Boolean(account_id);
}

function readStorage(key) {
    try {
        return sessionStorage.getItem(key) || '';
    } catch {
        return '';
    }
}

function writeStorage(key, value) {
    try {
        sessionStorage.setItem(key, value);
    } catch {
        // sessionStorage can be blocked; login then falls back to home.
    }
}

function removeStorage(key) {
    try {
        sessionStorage.removeItem(key);
    } catch {
        // sessionStorage can be blocked; login then falls back to home.
    }
}

export function rememberReturnPath(full_path) {
    if (isReturnablePath(full_path)) {
        writeStorage(RETURN_PATH_KEY, full_path);
    }
}

export function takeReturnPath() {
    const stored_path = readStorage(RETURN_PATH_KEY);
    removeStorage(RETURN_PATH_KEY);
    if (isReturnablePath(stored_path)) {
        if (pinsAccount(stored_path)) {
            writeStorage(KEEP_QUERY_ACCOUNT_KEY, '1');
        }
        return stored_path;
    }
    return HOME_PATH;
}

export function consumeKeepQueryAccount() {
    const should_keep = readStorage(KEEP_QUERY_ACCOUNT_KEY) === '1';
    if (should_keep) {
        removeStorage(KEEP_QUERY_ACCOUNT_KEY);
    }
    return should_keep;
}

export function clearReturnPath() {
    removeStorage(RETURN_PATH_KEY);
    removeStorage(KEEP_QUERY_ACCOUNT_KEY);
}

export function currentAppPath() {
    if (typeof window === 'undefined' || !window.location) {
        return '';
    }
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
}
